export default __webpack_public_path__ + "static/exotic_geometry-262274d19d9785512b8b325ce60070ec.png";